namespace Client
    module ListFunctions =
        let removeAt idx (arr: 'a list) =
            [
                for i in 0..arr.Length-1 do
                    if i = idx then
                        ()
                    else
                        yield arr.[i]
            ]
        let replace idGetter replacer (id: 'b) (list: 'a list) =
            let ret =
                list
                |> List.map (fun x -> if (idGetter x) = id then replacer x else x)
            ret

        let replaceAt replacer idx (list: 'a list) =
            [
                for i in 0..list.Length-1 do
                    if i = idx then
                        yield replacer list.[i]
                    else
                        yield list.[i]
            ]

        /// Potentially replaces an item in a list and folds a potential SideEffect through
        let replaceWithEffect idGetter replacer (id: 'b) (list: 'a list) =
            list
            |> List.fold (fun (acc, eff) x ->
                if (idGetter x) = id then
                    let item, cmd = replacer x
                    item::acc, cmd
                else
                    x::acc, eff
            ) ([], Illy.SafeStack.Client.Types.SideEffect.none)
            |> function (list, cmd) -> list |> List.rev, cmd
            
    module ArrayFunctions =
        let removeAt idx (arr: 'a[]) =
            [|
                for i in 0..arr.Length-1 do
                    if i = idx then
                        ()
                    else
                        yield arr.[i]
            |]

